import { Navigate, Outlet } from 'react-router-dom';

import { LoadingScreen } from '@/components/loading-screen';
import { login } from '@/lib/auth';
import { USER_TYPE } from '@/lib/data';
import { useAuthStore } from '@/store/auth';
import { useImpersonationStore } from '@/store/impersonation';

/**
 * Route guard that allows access only to authenticated Admin users.
 * Non-authenticated users are redirected to login.
 * Authenticated non-admin users are redirected to /403.
 */
export const AdminRoute = () => {
  const { isLoading, isAuthenticated, user } = useAuthStore();
  const { isImpersonating } = useImpersonationStore();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    login();

    return <LoadingScreen />;
  }

  // Allow through while impersonation is in progress — the page is mid-navigation
  if (!isImpersonating && user?.userType !== USER_TYPE.ADMIN) {
    return <Navigate to='/403' replace />;
  }

  return <Outlet />;
};
